import styled from 'styled-components';

export const ContainerStyled = styled.div<{ $isHidden: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  opacity: ${({ $isHidden }) => ($isHidden ? 0 : 1)};
  pointer-events: none;
`;
